export default __webpack_public_path__ + "static/media/category-tablets.ab919a9b.png";